import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, ConfigService, MessageService } from '../../../core';
import { ConfigEmpresa } from '../../configuracoes/app/empresa';

import { UnidadeNegocio } from '../unidade-negocio';
import { UnidadeNegocioCrudHttpService } from '../services';
import { unidadeNegocioSituacoes } from '../unidade-negocio-situacao';
import { lancamentos } from '../../../models';
import { unidadeNegocioReferenciasQuantidades } from '../unidade-negocio-referencia-quantidade';
import { UnidadeNegocioNaturezaVendaComponent } from '../natureza-venda';
import { UnidadeNegocioMercadoComponent } from '../mercado';
import { UnidadeNegocioLinhaProducaoComponent } from '../linha-producao';
import { ItemUnidade, ItemUnidadeCrudHttpService } from '../../item-unidade';
// import { UnidadeNegocioUsuarioComponent } from '../usuario';

@Component({
    selector: 'sgt-unidade-negocio-form',
    templateUrl: './unidade-negocio-form.component.html',
    styleUrls: ['./unidade-negocio-form.component.less']
})
export class UnidadeNegocioFormComponent implements BaseForm<UnidadeNegocio>, OnInit {
    configEmpresa: ConfigEmpresa;

    entity: UnidadeNegocio;
    editMode: boolean;
    @ViewChild('form') form: NgForm;
    situacoes = unidadeNegocioSituacoes;
    lancamentos = lancamentos;
    referenciasQuantidades = unidadeNegocioReferenciasQuantidades;
    unidades: ItemUnidade[] = [];

    // Usuários
    @ViewChild('unidadeNegocioMercadoForm') unidadeNegocioMercadoForm: UnidadeNegocioMercadoComponent;
    // @ViewChild('unidadeNegocioUsuario') unidadeNegocioUsuario: UnidadeNegocioUsuarioComponent;
    @ViewChild('unidadeNegocioNaturezaVendaForm') unidadeNegocioNaturezaVendaForm: UnidadeNegocioNaturezaVendaComponent;
    @ViewChild('unidadeNegocioLinhaProducaoForm') unidadeNegocioLinhaProducaoForm: UnidadeNegocioLinhaProducaoComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private baseFormService: BaseFormService,
                private configService: ConfigService,
                private messageService: MessageService,
                private itemUnidadeCrudHttpService: ItemUnidadeCrudHttpService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();

        this.searchUnidades();

        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        });
    }

    /** Pesquisa as unidades dos itens cadastradas */
    private searchUnidades() {
        this.itemUnidadeCrudHttpService.search()
            .subscribe(
                entities => this.unidades = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as unidades dos itens', error)
            );
    }

    load(id: number) {
        this.unidadeNegocioCrudHttpService.load(id)
            .subscribe(
                entity => this.entity = entity,
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a Unidade de Negócio', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new UnidadeNegocio();
        this.entity.idEmpresa = this.authService.getIdEmpresa();
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

     /** Valida se pode realizar o save */
     private validateSave(): boolean {
        // Usuários
        // if (!this.unidadeNegocioUsuario.isValid()) {
        //     this.baseFormService.showTabForm('#tabUsuarios');
        //     return false;
        // }
        // Mercados
        if (this.unidadeNegocioMercadoForm && !this.unidadeNegocioMercadoForm.isValid()) {
            this.baseFormService.showTabForm('#tabMercados');
            return false;
        }

        // Naturezas de Vendas
        if (this.unidadeNegocioNaturezaVendaForm && !this.unidadeNegocioNaturezaVendaForm.isValid()) {
            this.baseFormService.showTabForm('#tabNaturezasVendas');
            return false;
        }
        // Linhas de Produção
        if (this.unidadeNegocioLinhaProducaoForm) {
            if (!this.unidadeNegocioLinhaProducaoForm.isValid()) {
                this.baseFormService.showTabForm('#tabLinhasProducao');
                return false;
            }
        }

        return true;
    }


    private beforeSave() {
        // Usuários
        // this.unidadeNegocioUsuario?.resolve();
        // Mercados
        this.unidadeNegocioMercadoForm?.resolve();
        // Naturezas de Vendas
        this.unidadeNegocioNaturezaVendaForm?.resolve();
        // Linhas de Produção
        this.unidadeNegocioLinhaProducaoForm?.resolve();
    }

    save() {
        if (this.validateSave()) {
            this.beforeSave();
            this.baseFormService.save<UnidadeNegocio>(this.entity, this.form, this.editMode, this.unidadeNegocioCrudHttpService)
                .then(entity => {
                    this.messageService.success('', 'Unidade de Negócio salva com sucesso');
                    this.afterSave(entity);
                })
                .catch(error => {});
        }
    }

    afterSave(entity: UnidadeNegocio) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
